// extracted by mini-css-extract-plugin
module.exports = {"features":"FeaturesContainer_features__l8M-s","featureItem":"FeaturesContainer_featureItem__16MpX"};